import { Pagination, PaginationItem } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { DataGrid, GridRowId, GridSortDirection, gridPageCountSelector, gridPageSelector, gridPaginationSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { useEffect, useState } from 'react';
import { AddEquipmentButton, LongBlueButton, RecordTableContainer, RedButton, WhiteContainer } from '../assets/style';
import { useTranslation } from "react-i18next";

export interface RecordTableProps {
    getRowId?: (x: any) => any
    columns: TableHeader[];
    rows?: TableRow[];
    checkbox?: boolean;
    color?: string;
    deleteButton?: boolean;
    onClick?: (row: TableRow, field?: string) => void; // Add the onClick prop
    onSelectRows?: (selectedRows: any[]) => void;
    selectedRows?: TableRow[];
    pages?: number
    totalCount?: number
    length?: number
    fetchDataForPage?: (pageNumber: number, selectedRows?: any) => Promise<any[]>;
    updateTableRows?: (newRows: any[]) => void;
    workerEquipment?: any[]
}

export interface TableRow {
    id: any;
    data?: Array<React.ReactNode>;
    checked?: boolean;
}

export interface TableHeader {
    field: string;
    headerName: string;
    isSortable?: boolean;
    width: number;
    renderCell?: any;
}

const EquipmentRecordTable: React.FC<RecordTableProps> = ({ getRowId, columns, rows, checkbox, color, deleteButton, onClick, onSelectRows, selectedRows, pages, totalCount, length, fetchDataForPage, updateTableRows }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [sortBy, setSortBy] = useState('');
    const [direction, setDirection] = useState('');
    const [deletedRows, setDeletedRows] = useState<TableRow[]>([]);
    const [selectedRow, setSelectedRow] = useState<TableRow[]>(selectedRows || []);
    const [newPageRow, setNewPageRow] = useState<TableRow[]>([]);
    const [selectionModel, setSelectionModel] = useState<any>();
    const {t, i18n} = useTranslation();
    useEffect(() => {
        console.log("start use effect", rows)
        setSelectionModel(() =>
            rows
                ?.filter((r) => selectedRows?.some((row) => row.id === r.id))
                .map((r) => r.id))
        console.log("end use effect", rows
            ?.filter((r) => selectedRows?.some((row) => row.id === r.id))
            .map((r) => r.id))
    }, [rows, selectedRows, onSelectRows, fetchDataForPage]);

    const handleDeleteRows: React.MouseEventHandler<HTMLButtonElement> = () => {
        console.log("Deleted rows: ", deletedRows);
    };

    // const handleDeleteRows: React.MouseEventHandler<HTMLButtonElement> = () => {
    //     const remainingRows = rows.filter((row) => !checkedRows[row.id]);
    //     setDeletedRows(checkedRows);
    //     onDeleteRows && onDeleteRows(checkedRows);
    //     setEquipmentRows(remainingRows);
    //     setSelectedRows([]);
    // };

    if (!rows || rows.length === 0) {
        return (
            <WhiteContainer sx={{ margin: "28px", height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {t("No data available")}
            </WhiteContainer>
        );
    }
    const handleRowClick = (params: any) => {
        onClick && onClick(params.row, params?.field);
    };

    var rowCount = rows.length;
    const sortModel = sortBy && direction ? [{ field: sortBy, sort: direction as GridSortDirection }] : [];
    const CustomPagination = () => {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const paginationState = useGridSelector(apiRef, gridPaginationSelector);
        const currentPageSize = paginationState.paginationModel.pageSize * currentPage
        console.log("selectedRow", selectedRow)

        const handlePageChange = async (pageNumber: any, selectedRows: any) => {
            setCurrentPage(pageNumber - 1);
            const newPageData = await fetchDataForPage!(pageNumber, selectedRows);

            // Update the table rows
            updateTableRows!(newPageData);

            // Update the selected rows
            const newSelectedRows = newPageData.filter((row) => selectedRow.some((r) => r.id == row.id));
            const oldSelectedRows = selectedRow.filter((row) => newPageData.find((r: any) => r.id == row.id) == undefined);

            // setNewPageRow(newSelectedRows)
            //.filter(x => rows.find(x2 => x2.id == x.id) == undefined)
            const mergedArray = selectedRow.concat(newSelectedRows).concat(oldSelectedRows).concat(newPageRow)
            // console.log("combined filter 1111111111111", selectedRow.filter(x => rows.find(x2 => x2.id == x.id) == undefined))

            // const mergedArray = selectedRow.filter(x => rows.find(x2 => x2.id == x.id) == undefined).concat(newSelectedRows)
            const uniqueMergedArray = mergedArray.filter((item, index, self) =>
                index === self.findIndex((t) => (
                    t.id === item.id
                ))
            )
            console.log("uniqueMergedArray:", uniqueMergedArray)

            setSelectedRow(uniqueMergedArray);
            onSelectRows && onSelectRows(uniqueMergedArray);
        };
        return (
            <>
                {deleteButton && (

                    <RedButton onClick={handleDeleteRows}>Delete</RedButton>
                )}
                <Stack direction="row" spacing={2}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {
                            currentPageSize + 1
                        } - {
                            rowCount != 20 ?
                                totalCount : rowCount * (currentPage + 1)
                        } of {
                            totalCount
                        }
                    </Box>
                    <Pagination
                        color="primary"
                        count={pages}
                        page={currentPage + 1}
                        onChange={(event, value) => handlePageChange(value, selectedRows)}
                        variant="outlined"
                        shape="rounded"
                        sx={{
                            button: { borderColor: "#70BFEC" },
                        }}
                        renderItem={(item) => (
                            <PaginationItem
                                {...item}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "#B6E2FB",
                                        color: "#0D6EFD",
                                        borderColor: "transparent",
                                        fontSize: 16,
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "8px"
                                    }
                                }}
                            />
                        )}
                    />
                </Stack>
            </>
        );
    }
    return (
        <RecordTableContainer>
            <DataGrid
                keepNonExistentRowsSelected
                getRowId={getRowId}

                columns={columns.map((column) => ({
                    ...column,

                    width: column.width,
                    sortable: column.isSortable,
                }))}
                rows={rows}
                // rowSelectionModel={selectedRows?.map(x => x.id)}
                // rowSelectionModel={selectedRows?.map(x => x.id) as GridRowId[]}

                onCellClick={handleRowClick}
                // onRowClick={handleRowClick}
                sx={{
                    '&>.MuiDataGrid-main': {
                        '&>.MuiDataGrid-columnHeaders': {
                            borderBottomColor: '#2C93CD',
                            borderBottomWidth: "3px",
                            background: 'linear-gradient(180deg, #B6E2FB, #70BFEC)',
                        },
                    },
                    '& .MuiDataGrid-columnHeaders': { color: '#0D6EFD' },
                    borderColor: 'none',
                    backgroundColor: color ?? color

                }}

                rowSelectionModel={selectionModel}
                onRowSelectionModelChange={(e) => {
                    console.log("selectModel", e)
                    const selectedIDs = new Set(e);
                    // const selectedIDs = new Set([...selectedRows ?? [], e])
                    console.log("selectedIDs", selectedIDs)
                    const selectedRowData = rows.filter((row) => selectedIDs.has(row.id!)).map((row) => ({
                        ...row,
                        checked: row.checked,
                    }));

                    // console.log("combined filter", selectedRow.filter(x => rows.find(x2 => x2.id == x.id) == undefined))

                    console.log("selectedRowData", selectedRowData)
                    const mergedArray = selectedRow.filter(x => rows.find(x2 => x2.id == x.id) == undefined).concat(selectedRowData)
                    const uniqueMergedArray = mergedArray.filter((item, index, self) =>
                        index === self.findIndex((t) => (
                            t.id === item.id
                        ))
                    )

                    console.log(uniqueMergedArray)
                    setSelectedRow(uniqueMergedArray);
                    onSelectRows && onSelectRows(uniqueMergedArray);
                    setSelectionModel(e);
                    setNewPageRow(uniqueMergedArray)
                }}
                checkboxSelection={checkbox}
                initialState={{
                    pagination: {
                        paginationModel: { page: pages, pageSize: 20 },
                    },
                }}
                slots={{
                    pagination: CustomPagination,
                }}
                // autoHeight={true}
                sortModel={sortModel}
                disableColumnMenu
                onSortModelChange={(model) => {
                    if (model.length > 0) {
                        const { field, sort } = model[0];
                        setSortBy(field);
                        setDirection(sort as string);
                    } else {
                        setSortBy('');
                        setDirection('');
                    }
                }}
            />
        </RecordTableContainer>
    );
};
export default EquipmentRecordTable;
